import { render, staticRenderFns } from "./LotsUnderObservation.vue?vue&type=template&id=361f4445"
import script from "./LotsUnderObservation.vue?vue&type=script&lang=js"
export * from "./LotsUnderObservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports